// extracted by mini-css-extract-plugin
export default {"rotate":"media-slide-alignment-option-module__rotate--awau9"};